import React, { useEffect, useState } from "react";
import {
  useTheme,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Button,
  InputAdornment,
  Skeleton
} from "@mui/material";
import Fade from '@mui/material/Fade';
import { tokens } from "../theme";
import axios from "axios";
import Cookies from "js-cookie";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import Tooltip from '@mui/material/Tooltip';
import baseURL from "../config";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import SearchIcon from '@mui/icons-material/Search';
import CryptoJS from "crypto-js";
import RecordsTable from "../Components/RecordsTable";

const Levels = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [filteredLevels, setFilteredLevels] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const isNonMobile = useMediaQuery("(min-width:620px)");
  const [isLoading, setIsLoading] = useState(true);
  const [levelData, setLevelData] = useState({
    levelId: 0,
    levelName: "",
    minPoints: 0,
    maxPoints: 0,
    pointsValue: 0,
  });
  const [tabValue, setTabValue] = useState(0);
  const getDecryptedToken = () => {
    const encryptedToken = Cookies.get("token");
    if (!encryptedToken) return null;

    const secretKey = '19092002'; 
    const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

    return decryptedToken || null;
  };

 
  const token = getDecryptedToken();
  const [searchQuery, setSearchQuery] = useState("");

  const fetchLevels = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/Level/GetAllLevels`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        const levels = response.data;
        setIsLoading(false);
        setFilteredLevels(levels);
      } else {
        toast.error("Failed to fetch levels: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching levels data: ${error.message}`);
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  
  const fetchLevel = async (levelId) => {
    try {
      const response = await axios.get(`${baseURL}/api/Level/GetLevelById`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { id: levelId },
      });
      if (response.status === 200) {
        setLevelData(response.data);
        setDialogOpen(true);
      } else {
        toast.error("Failed to fetch level: Success flag is false.");
      }
    } catch (error) {
      toast.error(`Error fetching level: ${error.message}`);
    }
  };





  const handleEdit = (event) => {
    const { name, value } = event.target;
    setLevelData((prevData) => ({ ...prevData, [name]: value }));
  };


  const handleSave = async () => {
    if (!levelData.levelName || !levelData.minPoints || !levelData.maxPoints || !levelData.pointsValue) {
      toast.error("Please fill in all fields.");
      return;
    }
 
    
    try {
      const response = await axios.post(
        `${baseURL}/api/Level/UpdateLevel`,
        levelData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        toast.success("Leveli u përditësua me sukses!");
        await fetchLevels();
        setDialogOpen(false);
      } else {
        toast.error("Failed to update level.");
      }
    } catch (error) {
      toast.error(`Error updating level: ${error.message}`);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  }
  const filteredData = filteredLevels.filter((level) => {
    const levelName = level.levelName?.toLowerCase() || ""; 
    const minPoints = level.minPoints?.toString() || 0; 
    const maxPoints = level.maxPoints?.toString() || 0; 

  
    return (
        levelName.includes(searchQuery) ||
        minPoints.includes(searchQuery) ||
        maxPoints.includes(searchQuery) 
    );
  });
  

  const desktopColumns = [
    {
      field: "levelId",
      headerName: "ID",
      flex: 0.35,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-muted">#{params.value}</span>,
    },
    {
      field: "levelName",
      headerName: "Level",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "minPoints",
      headerName: "Min",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-pill">{params.value} pts</span>,
    },
    {
      field: "maxPoints",
      headerName: "Max",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-pill">{params.value} pts</span>,
    },
    {
      field: "pointsValue",
      headerName: "Value",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value}</span>,
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.35,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchLevel(params.row.levelId)}
          className="table-action-button"
          aria-label="Edit level"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const mobileColumns = [
    {
      field: "levelName",
      headerName: "Level",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-strong">{params.value || "N/A"}</span>,
    },
    {
      field: "pointsValue",
      headerName: "Value",
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <span className="table-pill">{params.value}</span>,
    },
    {
      field: "Actions",
      headerName: "",
      headerClassName: 'super-app-theme--header',
      flex: 0.45,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => fetchLevel(params.row.levelId)}
          className="table-action-button"
          aria-label="Edit level"
        >
          <DriveFileRenameOutlineIcon />
        </IconButton>
      ),
    },
  ];

  const columns = isNonMobile ? desktopColumns : mobileColumns
  return (
    <Box m="10px">
      <Header title="Levelet" subtitle="Detajet e Leveleve" />
      <ToastContainer />
      <Box mb={2} display="flex" justifyContent="flex-start">
        <TextField
          label="Search"
          variant="outlined"
          onChange={handleSearch}
          sx={{ backgroundColor: colors.primary[600], width: isNonMobile ? "30%" : "50%" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        
     
      </Box>
        
      <Box
        m="10px 0 0 0"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: "#3b0a45" },
          "& .MuiDataGrid-columnHeaders": {
           background: "black",
            borderBottom: "none",
             color: "#ffffff"
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[500],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.primary[800],
            color: "#ffffff"
           
          },
          "& .MuiButton-root": { color: "#ffffff" },
          "& .super-app-theme--header": {
            backgroundColor: colors.primary[200],
          },
          "& .MuiToolbar-root":{color :"#ffffff"},
          "&. MuiTablePagination-actions": {color: "white"}

        }}
      >
      <div style={{ width: "100%" }}>

      {isLoading ? (
         
         <Skeleton
           variant="rectangular"
           width="100%"
           height={500}
           animation="wave"
         />
       ) : (
        <RecordsTable
          columns={columns}
          rows={filteredData}
          getRowId={(row) => row.levelId}
          onRowDoubleClick={(params) => fetchLevel(params.row.levelId)} 
          emptyMessage="No levels match your search."
        />
       )}
     </div>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        
        <DialogContent
            className="custom-dialog-size"
            sx={{ backgroundColor: colors.primary[500], height: isNonMobile ? "" : "50vh",}}
          >
            <div className="tabs-container">
                <Tabs
                  variant="scrollable"
                  scrollButtons="auto"
                  value = {tabValue}  
                >
                  <Tab
                    label="Info per Level"
                    sx={{
                      color: "white",
                      backgroundColor: colors.primary[900],
                      margin: "2px",
                      borderRadius: "5px",
                  
                    }}
                  />
                  </Tabs>
              </div>
              <div
                    style={{
                      margin: "10px",
                      textAlign: "center",
                      display: isNonMobile ? undefined : "flex",
                      flexDirection: isNonMobile ? "row" : "column",
                    }}
                  >

          
            <TextField
              label="Level Name"
              name="levelName"
              value={levelData.levelName}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Min Points"
              name="minPoints"
              value={levelData.minPoints}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Max Points"
              name="maxPoints"
              value={levelData.maxPoints}
              onChange={handleEdit}
              fullWidth
              margin="dense"
            />
            <TextField
              label="Points Value"
              name="pointsValue"
              value={levelData.pointsValue}
              onChange={handleEdit}
              multiline
              fullWidth
              margin="dense"
            />
            
          </div>
        <DialogActions className="custom-dialog-background">
                <Button
                  onClick={() => setDialogOpen(false)}
                  sx={{ backgroundColor: "white" }}
                  >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{ backgroundColor: "white" }}
                  >
                  Save
                </Button>
              </DialogActions>
               </DialogContent>    
                </Dialog>
      </Box>
    </Box>
  );
};

export default Levels;
